module.exports = __webpack_public_path__ + "static/media/Canimolt_nuevo.a9b7824e.png";